import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'

import { styled } from '@clickcease/cc-client-components-lib'

export const RadioGroup = styled(RadioGroupPrimitive.Root, {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  paddingRight: '40px',
  overflow: 'auto',
  '> label': {
    marginBottom: '12px',
  },
})

export const StyledRadioFlex = styled('label', {
  all: 'unset',
  cursor: 'pointer',
  width: '260px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '12px',
  padding: '13px',
  border: '1px solid rgba(239, 239, 239, 1)',
  boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.05)',

  '&[aria-checked=true]': {
    backgroundColor: '$tableHovered',
  },

  variants: {
    active: {
      true: {
        backgroundColor: '$tableHovered',
      },
    },
  },
})

export const StyledRadio = styled(RadioGroupPrimitive.Item, {
  all: 'unset',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid rgba(40, 36, 33, 1)',
  borderRadius: '50%',
  width: '16px',
  height: '16px',

  '&[aria-checked=true]': {
    backgroundColor: '$primaryColor',
    border: '1px solid $primaryColor',
  },
})

export const RadioGroupIndicator = styled(RadioGroupPrimitive.Indicator, {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',

  '&::after': {
    content: '""',
    display: 'block',
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'white',
  },
})

export const Label = styled('label', {
  all: 'unset',
  color: '$mainTextColor',
  fontSize: 15,
  lineHeight: 1,
  paddingLeft: 15,
})

export const IconContainer = styled('span', {
  marginLeft: 'auto',
})
